export default __webpack_public_path__ + "static/media/app-gallery-black.8215dc71.svg";